export type Bonus = {
  number: string
  title: string
  body: string
  /** Optional cover image. Empty = the CSS cover in the product palette. */
  cover?: string
  /** Tailwind bg class for the CSS cover's accent band. */
  accent: string
}

export const bonuses: Bonus[] = [
  {
    number: '01',
    title: 'The 52-Week Table Calendar',
    body: 'Open it, pick your table type, and your next 52 weeks are mapped: which session to run, in what order, and when to drop in an event or a finale. Three calendars: rotating one-shots, weekly campaign, and multi-table GM.',
    cover: 'https://cdn.magicpatterns.com/uploads/t1koY8a18biBPfuQyknigZ/Bono_1_imagen.png',
    accent: 'bg-sage',
  },
  {
    number: '02',
    title: 'The Creature Quick Cards',
    body: 'Every creature used in the 57 sessions on a printable, VTT-friendly card, grouped by session. Print Thursday’s cards and you’re done looking things up.',
    cover: 'https://cdn.magicpatterns.com/uploads/wLMthfjFWwSupZdNBDi5cS/Bono_2_imagen.png',
    accent: 'bg-coral',
  },
  {
    number: '03',
    title: 'The Pro GM Screen Inserts',
    body: 'Six screen inserts with the rules questions that stall a paid table: conditions, actions in combat, cover, travel, rests and DCs. Clip them to any screen and keep the game moving.',
    cover: 'https://cdn.magicpatterns.com/uploads/6n8n5M2EsRRHmQz8bkXbZU/Bono_3_imagen.png',
    accent: 'bg-gold',
  },
  {
    number: '04',
    title: 'The Grab-and-Go Pre-Gen Party',
    body: 'Six complete, ready-to-play characters at levels 1, 3 and 5, built only with SRD options. Hand one to a first-timer and start on time.',
    cover: 'https://cdn.magicpatterns.com/uploads/qW5pF3yjACrnoWyU1FtoM8/Bono_4_imagen.png',
    accent: 'bg-smoke',
  },
  {
    number: '05',
    title: 'The Ambience Cue Sheets',
    body: 'For each of the 57 sessions: the mood, tempo and ambient layers for every scene, plus the exact search terms to find royalty-free tracks in minutes. No copyrighted music, no guesswork.',
    cover: 'https://cdn.magicpatterns.com/uploads/5RCuxHmtmxX4Qu5tK6hLAW/Bono_5_imagen.png',
    accent: 'bg-plum-mid',
  },
]
